/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nw_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a number, e.g. 1234`)
};

const es_nw_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa un número, p. ej. 1234`)
};

const de_nw_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie eine Zahl ein, z. B. 1234`)
};

const nl_nw_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer een getal in, bijv. 1234`)
};

const fr_nw_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez un nombre, par exemple 1234`)
};

const it_nw_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un numero, es. 1234`)
};

const pt_br2_nw_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite um número, ex: 1234`)
};

const pt_nw_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza um número, p.ex. 1234`)
};

const ja_nw_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字を入力してください。例: 1234`)
};

const zh_nw_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入一个数字，例如 1234`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nw_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nw_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nw_placeholder", locale)
	if (locale === "en") return en_nw_placeholder(inputs)
	if (locale === "es") return es_nw_placeholder(inputs)
	if (locale === "de") return de_nw_placeholder(inputs)
	if (locale === "nl") return nl_nw_placeholder(inputs)
	if (locale === "fr") return fr_nw_placeholder(inputs)
	if (locale === "it") return it_nw_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_nw_placeholder(inputs)
	if (locale === "pt") return pt_nw_placeholder(inputs)
	if (locale === "ja") return ja_nw_placeholder(inputs)
	return zh_nw_placeholder(inputs)
};